
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';

import projectGetActions from '../../sagas/project';
import createCommandItem from '../common/createCommandItem';
import DialogConfirm from '../common/DialogConfirm';

const classNames = mergeStyleSets({
    root: {
    }
});

const COMMAND_DELETE = {
    key: 'delete',
    name: 'Smazat projekt',
    iconName: 'Delete'
};

const ProjectCommandBar = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const auth = useSelector(state => state.auth);
    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = props.project.data.project.id;
    const canDeleteProject = (props.project.data.project.owner === auth.data.user.username);

    const handleDelete = async () => {
        const message = `Opravdu chcete smazat projekt "<b>${props.project.data.project.title}</b>"? <br/><br/>Data budou nenávratně smazána.`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            projectActions.delete(token, projectId);
        }
    }

    let commandItems = [];
    if (canDeleteProject) {
        commandItems.push(createCommandItem(COMMAND_DELETE, handleDelete));
    }

    return (
        <div className={classNames.root}>
            <CommandBar
                farItems={commandItems}
            />
        </div>
    )
}

export default ProjectCommandBar;
